import script from "./AccountDeletionConfirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountDeletionConfirmation.vue?vue&type=script&setup=true&lang=ts"

import "./AccountDeletionConfirmation.vue?vue&type=style&index=0&id=676c2e0a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-676c2e0a"]])

export default __exports__